export default "__VITE_ASSET__f53772bb__"